import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import errorImage from 'src/images/error.png'
import PageWrapper from 'src/layouts/ArtistLayout/PageWrapper'

const CustomErrorPage = () => {
  return (
    <PageWrapper>
      <Stack spacing={2} width="200px" m="0 auto">
        <img
          alt=""
          src={errorImage}
          style={{
            maxWidth: '160px',
            marginLeft: '-8px',
          }}
        ></img>
        <Typography fontWeight="bold">Oh no!</Typography>

        <Typography color="text.secondary" sx={{ margin: '0 auto' }}>
          Oh no! <br />
          Oh no! <br />
          We got it wrong <br />
          <br />
          Oh no! <br />
          Oh no! <br />
          We interrupted your song <br />
          <br />
          We logged this error <br />
          We&lsquo;ll get it fixed <br />
          Please don&lsquo;t be mad <br />
          Now get back to your mix <br />
        </Typography>
        <Button
          component="a"
          href="/"
          sx={{
            left: '-0.5rem',
            alignSelf: 'flex-start',
          }}
        >
          <Typography variant="h3">🏠</Typography>
        </Button>
      </Stack>
    </PageWrapper>
  )
}

export default CustomErrorPage
